import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import LinkIcon from '@atlaskit/icon/core/link';
import Button from '@atlaskit/button/button';

const i18n = defineMessages({
	copyLinkLabel: {
		id: 'share-and-restrict-dialog.copylink.icon.label',
		defaultMessage: 'Copy link',
		description: 'Label and tooltip for the button to copy content URL',
	},
});

export const CopyLinkButtonPlaceholder = () => {
	const intl = useIntl();
	return (
		<Button
			testId="copy-link-button-placeholder"
			data-test-id="copy-link-button-placeholder"
			appearance="subtle"
			iconBefore={<LinkIcon label={intl.formatMessage(i18n.copyLinkLabel)} spacing="spacious" />}
			isDisabled
		/>
	);
};
